import { h, Component } from 'preact';
import { route } from 'preact-router';
import Match from 'preact-router/match';
import Toolbar from 'preact-material-components/Toolbar';
import Button from 'preact-material-components/Button';
import Icon from 'preact-material-components/Icon';

import Menu from 'preact-material-components/Menu';


import { bind, memoize, debounce } from 'decko';
import { BaseComponent } from '../../common/BaseComponent';

import { IHeaderState, IHeaderProps } from './IHeader';
import { UserTypeEnum } from '../../enums/UserTypeEnum';

let style = require('./style.scss');

export class Header extends BaseComponent<IHeaderProps, IHeaderState> {

    private noMenuPaths = ["/register", "/register-with-options", "/confirm", "/settings/companyList", "/settings/updateUser", "/refresh"];
    private noBackPaths = ["/register", "/register-with-options", "/confirm", "/", "/scanCode", "/refresh"];

    public path: string;

    constructor(props, ctx) {
        super(props, ctx);
        this.commonService.setHeaderRef(this);
        this.auth.addOnAuthChangeEvent(() => {
            this.setState({ isLoggedIn: this.auth.isAuthenticated() && this.auth.hasAnyRoles(["ApiAccess"]) });
        });
        
        this.state = {
            isSwInitialized: false,
            isPushEnabled: false,
            darkThemeEnabled: false,
            delay: 10000,
            time: '',
            isLoggedIn: this.auth.isAuthenticated() && this.auth.hasAnyRoles(["ApiAccess"]),
            hideMenu: props.hideMenu
        }
        this.authService.getHeaderFooterImages().then((r) => {
            this.setState({ defaultFooterImage: r[1], defaultHeaderImage:r[0] });
        });
    }

    componentWillReceiveProps(p) {
        this.setState({ hideMenu: p.hideMenu });
    }

    @bind
    public setHeaderImage(url: string) {
        this.setState({ customHeaderImage: url });
    }

    @bind
    public setFooterImage(url: string) {
        this.setState({ customFooterImage: url });
    }

    public componentDidMount() {
        if (typeof window !== 'undefined') {
            //this.swsvc.initSw().then(() => {
            //    this.setState({
            //        isSwInitialized: this.swsvc.isSwInitialized,
            //        isPushEnabled: this.swsvc.isPushEnabled
            //    })
            //});
        }
    }


    @bind
    public settings() {
        this.refs.menu.MDComponent.open = false;
        (document.activeElement as any).blur();
        route("/settings/companyList", true);
    }

    @bind
    public update() {
        this.refs.menu.MDComponent.open = false;
        (document.activeElement as any).blur();
        route("/settings/updateUser", true);
    }

    @bind
    public logout() {
        this.modal.confirmation("Are you sure you wish to forget your log in details?", () => {
            this.auth.logout();
            (document.activeElement as any).blur();
            route("/register", true);
        }, "Yes", undefined, "No");
    }

    @bind
    public back() {
        //history.back();
        (document.activeElement as any).blur();
        var p = ["/b", "/settings", "/signout", "/signin", "/documents", "/workrequests"];
        if (p.filter((val) => { return this.path.startsWith(val); }).length > 0) {
            if (this.path.startsWith("/documents") || this.path.startsWith("/workrequests")) {
                p = this.path.split("/");
                if (this.path.endsWith("/"))
                    p.pop();
                p.pop();
                var newPath = p.join("/");
                if (!newPath)
                    newPath = "/";
                route(newPath, true);
            }
            else {
                route("/", true);
            }
        }
    }

    @bind
    public renderMenu({ matches, path, url }) {

        if (this.noMenuPaths.indexOf(path) > -1 || this.state.hideMenu || !this.state.isLoggedIn) {
            return "";
        }
        return <Menu.Anchor>
            <Toolbar.Icon onClick={e => { this.refs.menu.MDComponent.open = true; }}>more_vert</Toolbar.Icon>
            <Menu ref={this.setRef("menu")} >
                <Menu.Item onClick={this.update}><Icon>edit</Icon><span style="padding-left:10px">Update user details</span></Menu.Item>
                {this.auth.getUserType() == UserTypeEnum.Contractor && < Menu.Item onClick={this.settings}><Icon>settings</Icon><span style="padding-left:10px">My company list</span></Menu.Item>}
                <Menu.Item onClick={this.logout}><Icon>exit_to_app</Icon><span style="padding-left:10px">Forget my details</span></Menu.Item>
            </Menu>
        </Menu.Anchor>
    }

    @bind
    private renderBack({ matches, path, url }) {
        this.path = path;
        if (this.noBackPaths.indexOf(path) > -1 || this.state.hideMenu) {
            return "";
        }
        return <Button unelevated onClick={this.back}> <Icon>chevron_left</Icon>Back</Button >;
    }

    public render() {
        return <div>
            <Toolbar fixed className={style.toolbar}>
                <Toolbar.Row>
                    <Toolbar.Section align-start>
                        <Match path="/">
                            {this.renderBack}
                        </Match>
                    </Toolbar.Section>
                    <Toolbar.Section align-end={true}>
                        <Match path="/">
                            {this.renderMenu}
                        </Match>
                    </Toolbar.Section>
                    {this.state.customHeaderImage ? <div class={style.customlogo}><img src={this.state.customHeaderImage} /></div> : this.state.defaultHeaderImage ? <div class ={style.customlogo}><img src={this.state.defaultHeaderImage} /></div> : <div class={style.logo}></div> }
                </Toolbar.Row>
            </Toolbar>
            {this.state.customFooterImage ? <div class={style.customFooterLogo}><img src={this.state.customFooterImage} /></div> : this.state.defaultFooterImage ? <div class={style.customFooterLogo}><img src={this.state.defaultFooterImage} /></div> : ''}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./components/header/Header.tsx